/* ==========================================================================
   BESSER — Theme interactions
   No dependencies. Progressive enhancement over Shopify AJAX APIs.
   ========================================================================== */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const money = (cents) => {
    const fmt = (window.Besser && window.Besser.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  };

  /* ---------- Sticky header shadow ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Generic open/close with overlay & body lock ---------- */
  const overlay = $('#overlay');
  let lockCount = 0;
  function lockBody() { lockCount++; document.body.classList.add('no-scroll'); }
  function unlockBody() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('no-scroll'); }
  function showOverlay() { if (overlay) overlay.classList.add('is-active'); }
  function maybeHideOverlay() {
    if (!overlay) return;
    const anyOpen = $$('.mobile-nav.is-open, .cart-drawer.is-open, .search-panel.is-open').length > 0;
    if (!anyOpen) overlay.classList.remove('is-active');
  }
  function openPanel(el) { if (!el) return; el.classList.add('is-open'); showOverlay(); lockBody(); }
  function closePanel(el) { if (!el) return; el.classList.remove('is-open'); unlockBody(); maybeHideOverlay(); }

  /* ---------- Mobile nav ---------- */
  const mobileNav = $('#mobile-nav');
  $$('[data-open-menu]').forEach((b) => b.addEventListener('click', () => openPanel(mobileNav)));
  $$('[data-close-menu]').forEach((b) => b.addEventListener('click', () => closePanel(mobileNav)));

  /* ---------- Search panel ---------- */
  const searchPanel = $('#search-panel');
  const searchInput = $('#search-input');
  const searchResults = $('#search-results');
  $$('[data-open-search]').forEach((b) => b.addEventListener('click', () => {
    openPanel(searchPanel);
    setTimeout(() => searchInput && searchInput.focus(), 250);
  }));
  $$('[data-close-search]').forEach((b) => b.addEventListener('click', () => closePanel(searchPanel)));

  let searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(() => predictiveSearch(q), 250);
    });
  }
  function predictiveSearch(q) {
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        const items = (data.resources && data.resources.results) || {};
        const products = items.products || [];
        if (!products.length) {
          searchResults.innerHTML = `<p style="color:var(--color-muted);padding:8px 10px;">No products found for "${q}".</p>`;
          return;
        }
        searchResults.innerHTML = products.map((p) => {
          const img = (p.featured_image && p.featured_image.url) || (p.image) || '';
          return `<a href="${p.url}">
            ${img ? `<img src="${img}" alt="" loading="lazy">` : ''}
            <span><strong>${p.title}</strong><br><span style="color:var(--color-muted);font-size:.82rem;">${p.price ? money(p.price) : ''}</span></span>
          </a>`;
        }).join('') + `<a href="/search?q=${encodeURIComponent(q)}" style="font-weight:600;color:var(--color-primary);justify-content:center;">View all results →</a>`;
      })
      .catch(() => { searchResults.innerHTML = ''; });
  }

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('#cart-drawer');
  function openIcartOrFallback(retriesLeft = 30) {
    const icartBtn = document.querySelector('.iCartBtnToggle');
    if (icartBtn) { icartBtn.click(); return; }
    if (retriesLeft > 0) { setTimeout(() => openIcartOrFallback(retriesLeft - 1), 100); return; }
    openPanel(cartDrawer);
  }
  $$('[data-open-cart]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    openIcartOrFallback();
    refreshCart();
  }));
  $$('[data-close-cart]').forEach((b) => b.addEventListener('click', () => closePanel(cartDrawer)));

  /* ---------- Shiprocket checkout button inside the iCart drawer ----------
     Shiprocket's script only initializes .shiprocket-headless elements present
     at page load, so we create ONE persistent node up front and move (not
     recreate) it into iCart's checkout button group every time iCart re-renders
     that group, keeping Shiprocket's bound listeners intact. */
  const srCheckoutDiv = document.createElement('div');
  srCheckoutDiv.className = 'shiprocket-headless';
  srCheckoutDiv.dataset.type = 'cart';
  srCheckoutDiv.style.display = 'none';
  document.body.appendChild(srCheckoutDiv);

  function placeShiprocketInIcart() {
    const group = $('.icartCheckoutBtnGroup');
    if (!group) return;
    if (srCheckoutDiv.parentElement !== group) group.appendChild(srCheckoutDiv);
    srCheckoutDiv.style.display = '';
  }
  new MutationObserver(placeShiprocketInIcart).observe(document.body, { childList: true, subtree: true });
  placeShiprocketInIcart();

  let cartCache = null;

  function renderCart(cart) {
    cartCache = cart;
    const itemsEl = $('#cart-items');
    const subtotalEl = $('#cart-subtotal');
    const countEls = $$('.cart-count');
    countEls.forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count ? 'flex' : 'none'; });
    if (!itemsEl) return;

    if (!cart.item_count) {
      itemsEl.innerHTML = `<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--primary" style="margin-top:16px;">Shop Now</a></div>`;
      if (subtotalEl) subtotalEl.textContent = money(0);
      updateFreeShip(0);
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_120x120$1') : ''}" alt="" loading="lazy">
        <div>
          <div class="cart-line__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__meta">${item.variant_title}</div>` : ''}
          ${item.selling_plan_allocation ? `<div class="cart-line__meta">${item.selling_plan_allocation.selling_plan.name}</div>` : ''}
          <div class="qty-stepper">
            <button data-qty-down aria-label="Decrease">−</button>
            <input type="text" value="${item.quantity}" readonly aria-label="Quantity">
            <button data-qty-up aria-label="Increase">+</button>
          </div>
          <div><button class="cart-line__remove" data-remove>Remove</button></div>
        </div>
        <div class="cart-line__title">${money(item.final_line_price)}</div>
      </div>`).join('');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    updateFreeShip(cart.total_price);
    bindCartLineEvents();
  }

  function updateFreeShip(total) {
    const wrap = $('#cart-progress');
    if (!wrap) return;
    const threshold = parseInt(wrap.dataset.threshold || '0', 10);
    if (!threshold) { wrap.style.display = 'none'; return; }
    wrap.style.display = 'block';
    const pct = Math.min(100, (total / threshold) * 100);
    const fill = $('.cart-progress__fill', wrap);
    const label = $('.cart-progress__label', wrap);
    if (fill) fill.style.width = pct + '%';
    if (label) {
      label.textContent = total >= threshold
        ? "🎉 You've unlocked free shipping!"
        : `Add ${money(threshold - total)} more for free shipping`;
    }
  }

  function bindCartLineEvents() {
    $$('.cart-line').forEach((line) => {
      const key = line.dataset.key;
      const input = $('input', line);
      const qty = () => parseInt(input.value, 10) || 0;
      $('[data-qty-up]', line).addEventListener('click', () => changeQty(key, qty() + 1));
      $('[data-qty-down]', line).addEventListener('click', () => changeQty(key, qty() - 1));
      $('[data-remove]', line).addEventListener('click', () => changeQty(key, 0));
    });
  }

  function changeQty(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then((r) => r.json()).then(renderCart);
  }

  function refreshCart() {
    fetch('/cart.js').then((r) => r.json()).then(renderCart);
  }

  // Add to cart (any [data-add-to-cart] form or button with data-variant-id)
  function addToCart(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then((r) => r.json())
      .then((added) => {
        // Item is committed server-side now, safe for iCart to fetch fresh cart state
        openIcartOrFallback();
        // Merge added items into cached cart for instant render (no second round-trip needed)
        const addedItems = Array.isArray(added.items) ? added.items : [added];
        if (cartCache) {
          const optimistic = JSON.parse(JSON.stringify(cartCache));
          addedItems.forEach((newItem) => {
            const idx = optimistic.items.findIndex((i) => i.key === newItem.key);
            if (idx > -1) {
              optimistic.item_count += newItem.quantity - optimistic.items[idx].quantity;
              optimistic.total_price += newItem.final_line_price - optimistic.items[idx].final_line_price;
              optimistic.items[idx] = newItem;
            } else {
              optimistic.items.push(newItem);
              optimistic.item_count += newItem.quantity;
              optimistic.total_price += newItem.final_line_price;
            }
          });
          renderCart(optimistic);
        }
        // Background sync to reconcile discounts, totals, etc.
        return fetch('/cart.js').then((r) => r.json()).then((cart) => { renderCart(cart); return cart; });
      });
  }
  window.Besser = window.Besser || {};
  window.Besser.addToCart = addToCart;
  window.Besser.refreshCart = refreshCart;

  // Quick add buttons (cards / bundles)
  // document.addEventListener('click', (e) => {
  //   const btn = e.target.closest('[data-quick-add]');
  //   if (!btn) return;
  //   e.preventDefault();
  //   const ids = (btn.dataset.quickAdd || '').split(',').map((s) => s.trim()).filter(Boolean);
  //   if (!ids.length) return;
  //   btn.disabled = true; const prev = btn.textContent; btn.textContent = 'Adding…';
  //   const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
  //   addToCart({ items }).finally(() => { btn.disabled = false; btn.textContent = prev; });
  // });
  // document.addEventListener('click', (e) => {
  //   const btn = e.target.closest('[data-quick-add]');
  //   if (!btn) return;
  //   e.preventDefault();
  //   e.stopPropagation();   // beat iCart's anchor handler
  //   const ids = (btn.dataset.quickAdd || '').split(',').map((s) => s.trim()).filter(Boolean);
  //   if (!ids.length) return;
  //   btn.disabled = true; const prev = btn.textContent; btn.textContent = 'Adding…';
  //   const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
  //   addToCart({ items }).finally(() => { btn.disabled = false; btn.textContent = prev; });
  // }, true); --
  
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const ids = (btn.dataset.quickAdd || '').split(',').map((s) => s.trim()).filter(Boolean);
    if (!ids.length) return;
    btn.disabled = true; const prev = btn.textContent; btn.textContent = 'Adding…';
    const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
    addToCart({ items })
      .then(() => {
        // add is committed + /cart.js synced — now let Shiprocket open with fresh state
        const cartLink = btn.closest('a[href="/cart"]') || document.querySelector('a[href="/cart"]');
        if (cartLink) cartLink.click();
      })
      .finally(() => { btn.disabled = false; btn.textContent = prev; });
  }, true);
  // PDP / form add to cart
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const payload = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      const plan = fd.get('selling_plan');
      if (plan) payload.selling_plan = Number(plan);
      const submit = $('[type="submit"]', form);
      if (submit) { submit.disabled = true; submit.dataset.label = submit.textContent; submit.textContent = 'Adding…'; }
      addToCart(payload).finally(() => { if (submit) { submit.disabled = false; submit.textContent = submit.dataset.label; } });
    });
  });

  /* ---------- Quick view ---------- */
  const quickview = $('#quickview');
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger || !quickview) return;
    e.preventDefault();
    const handle = trigger.dataset.quickView;
    const body = $('#quickview-body');
    if (body) body.innerHTML = '<div style="padding:60px;text-align:center;">Loading…</div>';
    quickview.classList.add('is-open'); lockBody();
    fetch(`/products/${handle}?view=quickview`)
      .then((r) => r.text())
      .then((html) => { if (body) body.innerHTML = html; bindQuickViewForm(); })
      .catch(() => { if (body) body.innerHTML = '<div style="padding:60px;text-align:center;">Unable to load product.</div>'; });
  });
  function bindQuickViewForm() {
    const form = $('#quickview [data-product-form]');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      addToCart({ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) })
        .then(() => closeQuickView());
    });
  }
  function closeQuickView() { if (quickview) { quickview.classList.remove('is-open'); unlockBody(); } }
  $$('[data-close-quickview]').forEach((b) => b.addEventListener('click', closeQuickView));
  if (quickview) $('.quickview__backdrop', quickview) && $('.quickview__backdrop', quickview).addEventListener('click', closeQuickView);

  /* ---------- Wishlist (localStorage) ---------- */
  const WISH_KEY = 'besser_wishlist';
  const getWish = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } };
  const setWish = (a) => localStorage.setItem(WISH_KEY, JSON.stringify(a));
  function syncWishUI() {
    const list = getWish();
    $$('[data-wishlist]').forEach((btn) => btn.classList.toggle('is-active', list.includes(btn.dataset.wishlist)));
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.style.display = list.length ? 'flex' : 'none'; });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.wishlist; const list = getWish();
    const idx = list.indexOf(id);
    if (idx > -1) list.splice(idx, 1); else list.push(id);
    setWish(list); syncWishUI();
  });
  syncWishUI();

  /* ---------- FAQ accordion ---------- */
  $$('.faq__q').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq__item');
      const a = $('.faq__a', item);
      const open = item.classList.toggle('is-open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });

  /* ---------- PDP tabs ---------- */
  $$('[data-tabs]').forEach((tabs) => {
    const btns = $$('[data-tab]', tabs);
    const panels = $$('[data-panel]', tabs);
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => x.classList.remove('is-active'));
      panels.forEach((x) => x.classList.remove('is-active'));
      b.classList.add('is-active');
      const target = $(`[data-panel="${b.dataset.tab}"]`, tabs);
      if (target) target.classList.add('is-active');
    }));
  });

  /* ---------- PDP purchase options (one-time / subscribe) ---------- */
  $$('[data-purchase-options]').forEach((wrap) => {
    $$('.purchase-option', wrap).forEach((opt) => {
      const radio = $('input', opt);
      radio.addEventListener('change', () => {
        $$('.purchase-option', wrap).forEach((o) => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
      });
    });
  });

  /* ---------- PDP gallery carousel ---------- */  
  $$('[data-gallery]').forEach((g) => {
    const slides = $$('[data-gallery-slide]', g);
    if (!slides.length) return;
    const thumbs = $$('[data-gallery-thumb]', g);
    const dots = $$('[data-gallery-dot]', g);
    const prev = $('[data-gallery-prev]', g);
    const next = $('[data-gallery-next]', g);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = parseInt(g.dataset.galleryAutoplay, 10) || 4000;
    let current = 0;
    let timer = null;

    const go = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      thumbs.forEach((t) => t.classList.toggle('is-active', +t.dataset.galleryThumb === current));
      dots.forEach((d) => d.classList.toggle('is-active', +d.dataset.galleryDot === current));
    };

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      if (reduceMotion || slides.length < 2 || document.hidden) return;
      stop();
      timer = setInterval(() => go(current + 1), delay);
    };

    prev && prev.addEventListener('click', () => { go(current - 1); start(); });
    next && next.addEventListener('click', () => { go(current + 1); start(); });
    thumbs.forEach((t) => t.addEventListener('click', () => { go(+t.dataset.galleryThumb); start(); }));
    dots.forEach((d) => d.addEventListener('click', () => { go(+d.dataset.galleryDot); start(); }));

    // Pause on hover / when tab is hidden; resume otherwise.
    g.addEventListener('mouseenter', stop);
    g.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    start();
  });

  /* ---------- Carousels (testimonials) ---------- */
  $$('[data-carousel]').forEach((c) => {
    const track = $('[data-carousel-track]', c);
    const prev = $('[data-carousel-prev]', c);
    const next = $('[data-carousel-next]', c);
    if (!track) return;
    const step = () => Math.min(track.clientWidth * 0.85, 400);
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    if (c.dataset.autoplay === 'true') {
      let timer = setInterval(() => {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, 5000);
      c.addEventListener('mouseenter', () => clearInterval(timer));
    }
  });

  /* ---------- Banner slider ---------- */
  $$('[data-banner-slider]').forEach((slider) => {
    const track = $('[data-slider-track]', slider);
    const slides = $$('[data-slide]', slider);
    if (!track || slides.length === 0) return;
    const dots = $$('[data-slider-dot]', slider);
    const prev = $('[data-slider-prev]', slider);
    const next = $('[data-slider-next]', slider);
    const total = slides.length;
    let index = 0;
    let timer = null;
    const autoplay = slider.dataset.autoplay === 'true' && total > 1;
    const interval = parseInt(slider.dataset.interval, 10) || 5000;

    function go(i) {
      index = (i + total) % total;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }
    function nextSlide() { go(index + 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(nextSlide, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    prev && prev.addEventListener('click', () => { go(index - 1); start(); });
    next && next.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.sliderDot, 10)); start(); }));

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    // Touch / swipe
    let startX = 0, dx = 0, dragging = false;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; dragging = true; stop(); }, { passive: true });
    track.addEventListener('touchmove', (e) => { if (dragging) dx = e.touches[0].clientX - startX; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (dragging && Math.abs(dx) > 50) { dx < 0 ? nextSlide() : go(index - 1); }
      dragging = false; dx = 0; start();
    });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });

    go(0);
    start();
  });

  /* ---------- Scroll reveal (with auto stagger for grid siblings) ---------- */
  $$('.grid, .ig-track, .testi-carousel, .why-grid, .mv-grid, .pdp-highlights__grid').forEach((group) => {
    Array.from(group.children).forEach((child, i) => {
      if (child.classList && child.classList.contains('reveal')) {
        child.setAttribute('data-reveal-delay', String(Math.min(i % 5, 5)));
      }
    });
  });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Scroll progress bar ---------- */
  const progress = document.createElement('div');
  progress.className = 'scroll-progress';
  document.body.appendChild(progress);
  const updateProgress = () => {
    const h = document.documentElement;
    const max = h.scrollHeight - h.clientHeight;
    progress.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
  };
  window.addEventListener('scroll', updateProgress, { passive: true });
  updateProgress();

  /* ---------- Back to top ---------- */
  const toTop = document.createElement('button');
  toTop.className = 'to-top';
  toTop.setAttribute('aria-label', 'Back to top');
  toTop.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
  document.body.appendChild(toTop);
  toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  window.addEventListener('scroll', () => {
    toTop.classList.toggle('is-visible', window.scrollY > 600);
  }, { passive: true });

  /* ---------- Email popup ---------- */
  const popup = $('#email-popup');
  if (popup) {
    const KEY = 'besser_popup_seen';
    const delay = parseInt(popup.dataset.delay || '6', 10) * 1000;
    if (!sessionStorage.getItem(KEY)) {
      setTimeout(() => { popup.classList.add('is-open'); }, delay);
    }
    const close = () => { popup.classList.remove('is-open'); sessionStorage.setItem(KEY, '1'); };
    $$('[data-close-popup]', popup).forEach((b) => b.addEventListener('click', close));
    const backdrop = $('.popup__backdrop', popup);
    backdrop && backdrop.addEventListener('click', close);
  }

  /* ---------- Sticky mobile ATC visibility ---------- */
  const stickyAtc = $('#sticky-atc');
  if (stickyAtc) {
    document.body.classList.add('has-sticky-atc');
    const mainForm = $('[data-product-form]');
    const io2 = new IntersectionObserver((entries) => {
      entries.forEach((en) => stickyAtc.classList.toggle('is-visible', !en.isIntersecting));
    }, { threshold: 0 });
    if (mainForm) io2.observe(mainForm);
    const stickyBtn = $('[data-sticky-add]', stickyAtc);
    if (stickyBtn && mainForm) stickyBtn.addEventListener('click', () => mainForm.requestSubmit());
  }

  /* ---------- Overlay click closes panels ---------- */
  if (overlay) overlay.addEventListener('click', () => {
    closePanel(mobileNav); closePanel(cartDrawer); closePanel(searchPanel);
  });

  /* ---------- Escape closes everything ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closePanel(mobileNav); closePanel(cartDrawer); closePanel(searchPanel);
    closeQuickView();
    if (popup) popup.classList.remove('is-open');
  });

  // Initial cart count sync
  refreshCart();
})();
